import { getSignal } from '@api/index';
import { HydratedEntity } from 'src/types';

export const getSelectField = <T>(field: string) => (entity: HydratedEntity) =>
    getSignal<T | null>(entity, field, null) as T;
